import { takeLatest } from "redux-saga/effects";
import {
  CreateBeneficiary,
  GetBeneficiary,
  GetByBeneficiary,
} from "./beneficiary";
import { sagaFunctions } from "../../utils";
import { apis } from "../../config/APIs";

function getBeneficiarySage(req) {
  return sagaFunctions(
    GetBeneficiary,
    "get",
    apis.getBeneficiaryAPI,
    req.payload,
    { skipSuccessMessage: true },
  )();
}

function createBeneficiarySage(req) {
  return sagaFunctions(
    CreateBeneficiary,
    "post",
    req?.payload?.id ? apis.updateBeneficiaryAPI : apis.createBeneficiaryAPI,
    req.payload,
  )();
}
function getByIDBeneficiarySage(req) {
  return sagaFunctions(
    GetByBeneficiary,
    "get",
    apis.getByIDBeneficiaryAPI,
    req.payload,
  )();
}

export function* beneficiaryWarcher() {
  yield takeLatest(GetBeneficiary?.REQUEST, getBeneficiarySage);
  yield takeLatest(CreateBeneficiary?.REQUEST, createBeneficiarySage);
  yield takeLatest(GetByBeneficiary?.REQUEST, getByIDBeneficiarySage);
}
